import { sample } from "effector";
import { confirmChangePassword, resetErrors, setInputValue } from "./events";
import { $changePasswordStore } from "./store";
import { $validTokenAndQuery } from "../../../entities/passwordReset/models/store";
import { confirmChangePasswordFx } from "./effects";
import { showErrorToastFx } from "../../../shared/lib/notify/showErrorToast";
import { showSuccessToastFx } from "../../../shared/lib/notify/showSuccessToast";


sample({
    clock: setInputValue,
    source: $changePasswordStore,
    filter: (store, input) => Boolean(
        store[input.key].errorMessage
        && !store[input.key].isValid
    ),
    fn: (_, input) => input.key,
    target: resetErrors,
})


sample({
    clock: confirmChangePassword,
    source: {
        passwordStore: $changePasswordStore,
        tokenAndQuery: $validTokenAndQuery,
    },
    filter: ({ tokenAndQuery }) =>
        Boolean(
            tokenAndQuery.validToken?.is_valid &&
            tokenAndQuery.query?.uid &&
            tokenAndQuery.query?.token
        ),
    fn: ({ passwordStore, tokenAndQuery }) => ({
        uid: tokenAndQuery.query!.uid,
        token: tokenAndQuery.query!.token,
        new_password: passwordStore.newPassword.value,
    }),
    target: confirmChangePasswordFx,
});


sample({
    clock: confirmChangePasswordFx.failData,
    fn: (error) => error.message,
    target: showErrorToastFx,
});


sample({
    clock: confirmChangePasswordFx.done,
    fn: () => 'Пароль успешно изменён. Теперь вы можете войти в систему с новым паролем.',
    target: showSuccessToastFx,
});
